import { ArgumentError } from '../utils/errors';

import { BaseAPIModel } from '@weezevent/weezjs-core';
import { computeGroupDisplayOrder } from './rateGroup';

const NB_DIGIT_BY_LEVEL = 4;
const NB_SUB_LEVEL = 3;

export default class RateTemplateGroup extends BaseAPIModel {
    fields() {
        return {
            uuid: { readOnly: true, primaryKey: true },
            name: {}
        };
    }

    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][RateGroup][getAll] organizationId is mandatory`);
        }

        return `/ticket/organizations/${organizationId}/rate_groups`;
    }

    static sort(groups) {
        const groupsById = {};
        groups.forEach(group => {
            group.groupDisplayOrder = null;
            groupsById[group.pk] = group;
        });
        groups.forEach(group => {
            group.parentGroup = group.parent === null ? null : groupsById[group.parent];
            computeGroupDisplayOrder(group, groupsById);
            group.groupDisplayOrder = Number(group.normalizedDisplayOrder) * 10 ** ((NB_SUB_LEVEL - group.parentLevel) * NB_DIGIT_BY_LEVEL);
        });

        if (!groups.length || groups[0].groupDisplayOrder === undefined) {
            return groups;
        }
        groups.sort((el1, el2) => el1.groupDisplayOrder - el2.groupDisplayOrder);
        return;
    }
    /*
        When the groups are "sort", we have the parentGroup relation between objects
        This method allow to follow an attrName through parents.
        Example use case : attr "showRates" is used to hide rates in subcategory in rates manager page.
        if a parent group as "showRates" to False, then the sub group need to be hidden.
    */
    getAttributeFromParent(attrName, defaultValue) {
        if (this.parentGroup === null || this.parentGroup === undefined) {
            return defaultValue;
        }

        return this.parentGroup.getAttributeFromParent(attrName, this.parentGroup[attrName]);
    }
}
